import React from "react";
import {
    Box, Grid, Typography,
    TextField, Stack, RadioGroup,
    FormControlLabel, Radio,
    Button, Card,
} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {
    Refresh as RefreshIcon,
    Delete as DeleteIcon,
} from '@mui/icons-material';

const AiGenerate = (props) => {
    const { fetchAI, changeSave, name } = props
    const classes = useStyles();

    const [value, setValue] = React.useState();
    const [valueDesc, setValueDesc] = React.useState();
    const [valueDescShort, setValueDescShort] = React.useState();

    const [radioName, setRadioName] = React.useState("");
    const [names, setNames] = React.useState([]);
    const [isLoadingName, setIsLoadingName] = React.useState(false);

    const [isLoading, setLoading] = React.useState(false);

    const changeGenerateName = () => {
        setIsLoadingName(true);

        if (isLoadingName) return

        fetchAI({}, {generate: "name"})
            .then(data => {
                setNames([...data?.names])
            })
            .finally(() => {
                setIsLoadingName(false);
            })
    }

    const saveParamValue = (param, value) => {
        changeSave(param, value)
    }

  return (
      <Grid container spacing={3}>
          <Grid item xs={12}>
              <Box className={classes.whiteSection}>
                  <Stack spacing={1} mb={3}>
                      <Typography variant="h2">Описание вашего товара</Typography>
                      <Typography variant="p">Опишите основные характеристики и преимущества товара</Typography>
                  </Stack>
                  <TextField
                      size="small"
                      placeholder="Например: Кольцо выполнено из серебра 925 пробы и украшено овальным вставкой из натурального аметиста. Камень закреплён в аккуратной короне-крапановой оправе, что подчёркивает его естественное сияние. Поверхность изделия отполирована до зеркального блеска, дизайн лаконичный и универсальный"
                      type='string'
                      maxRows={10}
                      minRows={3}
                      multiline
                      fullWidth
                      hiddenLabel
                  />
              </Box>
              <Box className={classes.whiteSection}>
                  <Box marginBottom={3}>
                      <Stack spacing={1} mb={3}>
                          <Typography variant="h2">Название товара</Typography>
                          <Typography variant="p">Выберите использовать текущее название или сгенерировать новое</Typography>
                      </Stack>
                      { name }
                      <RadioGroup
                          aria-labelledby="demo-error-radios"
                          name="quiz"
                          value={value}
                          onChange={(e) => setValue(e.target.value)}
                      >
                          <FormControlLabel
                              value="current"
                              control={<Radio disabled={!name} />}
                              disabled={!name}
                              label={`Использовать текущее название ${name ? name : ''}`}
                          />
                          <FormControlLabel
                              value="create"
                              control={<Radio />}
                              label="Сгенерировать новые названия"
                          />
                      </RadioGroup>
                  </Box>
                  {
                      value === "create" && (
                          <Stack spacing={2}>
                              <Stack spacing={1} direction="row">
                                  <Button variant="contained" color="primary" size="small" onClick={changeGenerateName} disabled={isLoadingName}>
                                      Генерировать названия
                                  </Button>
                                  <Button variant="outlined" color="primary" size="small" onClick={changeGenerateName} disabled={isLoadingName}>
                                      <RefreshIcon />
                                  </Button>
                              </Stack>
                              <Stack>
                                  {
                                      names.length > 0 ? (
                                          <Typography variant="p">Выберите одно из предложенных названий:</Typography>
                                      ) : null
                                  }
                                  <RadioGroup
                                      value={radioName}
                                      onChange={(e) => setRadioName(e.target.value)}
                                  >
                                      {
                                          names.map((item) => (
                                              <FormControlLabel
                                                  key={item}
                                                  value={item}
                                                  control={<Radio />}
                                                  label={item}
                                                  disabled={isLoadingName}
                                              />
                                          ))
                                      }
                                  </RadioGroup>
                                  {
                                      radioName ? (
                                          <Button variant="contained" color="primary" size="small" disabled={isLoadingName} onClick={() => saveParamValue('name', )}>
                                              Применить
                                          </Button>
                                      ) : null
                                  }
                              </Stack>
                          </Stack>
                      )
                  }
              </Box>
              <Box className={classes.whiteSection}>
                  <Stack spacing={1} mb={3}>
                      <Typography variant="h2">Описания товара</Typography>
                      <Typography variant="p">Сгенерируйте подробное и краткое описание товара</Typography>
                  </Stack>
                  <Stack spacing={5} mb={3}>
                      <Card variant="outlined" sx={{ p: 2, backgroundColor: "#f5f5f5" }}>
                          <Typography variant="p">Подробное описание</Typography>
                          <Stack direction="row" spacing={2} sx={{ mt: 1, mb: 2 }}>
                              <Button variant="contained" color="primary" size="small">
                                  Сгенерировать
                              </Button>
                              <Button
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  sx={{ height: 38 }}
                              >
                                  <DeleteIcon />
                              </Button>
                          </Stack>
                          <TextField
                              size="small"
                              placeholder="Например: данное изделие..."
                              type='string'
                              maxRows={10}
                              minRows={3}
                              value={valueDesc}
                              onChange={(e) => setValueDesc(e.target.value)}
                              multiline
                              fullWidth
                              hiddenLabel
                          />
                          <Button variant="contained" color="primary" size="small" sx={{ marginTop: 2 }}>Сохранить</Button>
                      </Card>
                      <Card variant="outlined" sx={{ p: 2, backgroundColor: "#f5f5f5" }}>
                          <Typography variant="p">Краткое описание</Typography>
                          <Stack direction="row" spacing={2} sx={{ mt: 1, mb: 2 }}>
                              <Button variant="contained" color="primary" size="small">
                                  Сгенерировать
                              </Button>
                              <Button
                                  variant="outlined"
                                  color="primary"
                                  size="small"
                                  sx={{ height: 38 }}
                              >
                                  <DeleteIcon />
                              </Button>
                          </Stack>
                          <TextField
                              size="small"
                              placeholder="Например: данное изделие..."
                              type='string'
                              maxRows={10}
                              minRows={3}
                              value={valueDescShort}
                              onChange={(e) => setValueDescShort(e.target.value)}
                              multiline
                              fullWidth
                              hiddenLabel
                          />
                          <Button variant="contained" color="primary" size="small" sx={{ marginTop: 2 }}>Сохранить</Button>
                      </Card>
                  </Stack>
              </Box>
          </Grid>
       </Grid>
  )
}

const useStyles = makeStyles(() => ({
    whiteSection: {
        padding: "20px",
        borderRadius: "10px",
        backgroundColor: "white",
        boxSizing: "border-box",
        marginTop: "20px",

        "&:first-of-type": {
            marginTop: 0
        }
    }
}));

export default React.memo(AiGenerate)
